<div class="flex vcenter bank-account-header">
  <h2>Bankszámla</h2>
  @if (!lock_bank_account.value) {
    <button
      payee-icon-button
      color="white"
      type="button"
      [isBorderButton]="true"
      (click)="openLockDialog()"
    >
      <payee-icon name="pencil"></payee-icon>
    </button>
  }
  @if (lock_bank_account.value) {
    <button
      payee-icon-button
      color="white"
      type="button"
      [isBorderButton]="true"
      (click)="openUnlockDialog()"
    >
      <payee-icon name="lock-grey"></payee-icon>
    </button>
  }
</div>
<payee-form-field>
  <input
    payee-input
    [formControl]="account_number"
  />
  <span payee-label>BBAN/IBAN</span>
  @if (account_number.invalid && account_number.dirty) {
    <ng-container payee-error>
      @if (account_number.hasError("pattern")) {
        <span>Helytelen formátum!</span>
      }
    </ng-container>
  }
</payee-form-field>
<payee-form-field>
  <input
    payee-input
    [formControl]="bic"
  />
  <span payee-label>BIC</span>
</payee-form-field>
<payee-form-field>
  <input
    payee-input
    [formControl]="bank_name"
  />
  <span payee-label>Számlavezető bank neve</span>
</payee-form-field>
